<template>
  <v-container>
    <v-form
        ref="capSettingsform"
    >
    <v-row>
      <v-col cols="12" class="pb-0">

          <CAPSelectorComponent
              @changedClient="handle_changed_client"
              @changedProject="handle_changed_project"
              @loadingStateChanged="handleLoadingStateChanged"
              :form-disabled="formDisabled"
          ></CAPSelectorComponent>
          <v-text-field
              v-if="appSettings.usesProjectWorkDistance"
              v-model="project_distance"
              :rules="distanceRules"
              :label="$vuetify.lang.t('$vuetify.cap_settings.project_distance')"
              type="number"
              required
          ></v-text-field>
          <v-text-field
              v-if="appSettings.usesProjectWorkShift"
              v-model="project_shift"
              :rules="shiftRules"
              :label="shift_label"
              required
          ></v-text-field>
      </v-col>
    </v-row>
      <!-- TAG CODE SCANNER - ONLY WHEN ACTIVATED -->
      <v-row v-if="enableTAGCodeScanner">
        <v-col cols="9" class="pb-0 pt-0">
          <v-text-field
              v-model="project_tag_code"
              :rules="tagCodeRules"
              :label="$vuetify.lang.t('$vuetify.cap_settings.project_tag_code_label')"
              :disabled="tagInputDisabled"
              :required="TAGCodeMandatory"
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="pt-0 d-flex justify-center align-center">
          <v-btn
              color="cyan"
              dark
              fab
              class="btn--shockwave"
              @click="display_scanner = true"
          ><v-icon center dark>{{icons.mdiQrcodeScan}}</v-icon>
          </v-btn>
        </v-col>

      </v-row>
      <!-- TAG CODE SCANNER  -->
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-btn class="mr-4 mt-4" @click="save" color="primary" :dark="!formDisabled" :disabled="formDisabled">{{ $vuetify.lang.t('$vuetify.global.continue') }}</v-btn>
      </v-col>
    </v-row>
    </v-form>
    <simple-popup-component
        :is-visible="display_cn_pid_error"
        :title="error_title"
        :body="error_body"
        @positive_btn_clicked="display_cn_pid_error = false"
    ></simple-popup-component>
    <CAPSTAGCodeScanOverlayComponent
        v-if="display_scanner"
        :scanner_active="display_scanner"
        @validTAGScanned="scanSuccessful"
        @closedWithError="useManualTAGInput"
        @userCanceled="close_scanner"
        @unlockTAGInput="useManualTAGInput"
    >
    </CAPSTAGCodeScanOverlayComponent>
  </v-container>
</template>

<script>
import {mobileCheckMixin} from "../../../mixins/MobileCheckMixin/MobileCheckMixin";
import LMRAVCChildComponentMixin  from "@/mixins/LMRAViewComponent/LmraViewComponentChildComponentMixin";
//import {MainEventBus} from "../../../MainEventBus";
import {clientProjectSettings} from "../../../classes/ClientProjectSettingsClass";
import appSettings from "../../../mixins/config/appSettings"
import CAPSelectorComponent from "@/components/modules/settings/CAPSelectorComponent";
import SimplePopupComponent from "@/components/modules/global/simplePopup/SimplePopupComponent";
import { mdiQrcodeScan } from "@mdi/js";
//import {capsSavedEvent, CAPSettingsEventEmitter} from "../../../EventBusses/CPSettingsEventBus";
import CAPSTAGCodeScanOverlayComponent from "@/components/modules/settings/CAPSTAGCodeScanOverlayComponent";
import {TAGCodeValidator} from "@/helpers/capSettings/TAGCodeValidator";

export default {
  name: "ClientProjectSettings",
  components: {SimplePopupComponent, CAPSelectorComponent, CAPSTAGCodeScanOverlayComponent},
  props : {
    enableTAGCodeScanner : {
      type: Boolean,
      default : false
    },
    TAGCodeMandatory : {
      type: Boolean,
      default : false
    }
  },
  data() {
    return {
      client: '',
      project: '',
      project_distance: '',
      project_shift: '',
      project_tag_code : '',
      distance_char_limit: 4,
      shifts_char_limit : 200,
      display_cn_pid_error : false,
      error_title : '',
      error_body : '',
      display_scanner : false,
      tagInputDisabled : true,
      icons : {
        mdiQrcodeScan
      },
      formDisabled : true
    }
  },
  computed: {
    //TEMP SOLUTION
    shift_label(){
      var shiftsLabel = this.$vuetify.lang.t('$vuetify.cap_settings.project_shift');
      if(this.appSettings.customShiftsInputLabelKey){
        switch(this.appSettings.customShiftsInputLabelKey){
          case 'openField':
            shiftsLabel = this.$vuetify.lang.t('$vuetify.cap_settings.custom_shifts_labels.open_field');
            break;
        }
      }
      return shiftsLabel
    },
    distanceRules() {
      const rules = [];
      if (this.appSettings.usesProjectWorkDistance) {
        if (this.distance_char_limit) {
          const rule =
              v => (v.trim() || '').length <= this.distance_char_limit ||
                  this.$vuetify.lang.t('$vuetify.errors.input_validation.char_limit').replace('%n', this.distance_char_limit )


          rules.push(rule)
        }
        const min_length_rule =
            v => (v.trim() || '').length >= 1 || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
        rules.push(min_length_rule)
      }
      return rules
    },
    shiftRules() {
      const rules = [];
      if (this.appSettings.usesProjectWorkShift) {
        const rule =
            v => (v.trim() || '').length <= this.shifts_char_limit ||
                this.$vuetify.lang.t('$vuetify.errors.input_validation.char_limit').replace('%n', this.shifts_char_limit )

        rules.push(rule)

        const min_length_rule =
            v => (v.trim() || '').length >= 2 || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
        rules.push(min_length_rule)
      }
      return rules;
    },
    tagCodeRules(){
      const rules = [];
      if (this.enableTAGCodeScanner) {

        if(this.TAGCodeMandatory){
          const min_length_rule =
              v => (v.trim() || '').length >= 1 || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
          rules.push(min_length_rule)
        }

        const valid_code_rule = v => {
          if(v.length > 0){
              return TAGCodeValidator.validate_TAG_CODE(v) || 'invalid format';
          }else{
            return true;
          }
        }
        rules.push(valid_code_rule)
      }
      return rules;
    },
    valid_client() {
      return (this.client === null || this.client.id === undefined || this.client.name.trim().length <= 0) ? false : true;
    },
    valid_project() {
      return (this.project === null || this.project.id === undefined || this.project.name.trim().length <= 0) ? false : true;
    }
  },
  methods: {
    handleLoadingStateChanged($isLoading){
      window.console.log('LOADING CHANGED')
      window.console.log('STATE IS NOW : '+$isLoading);
      this.formDisabled = ($isLoading)? true : false
    },
    useManualTAGInput(){
      this.close_scanner();
      this.tagInputDisabled = false;
    },
    scanSuccessful($string){
      this.close_scanner();
      this.project_tag_code = $string;
    },
    close_scanner(){
      this.display_scanner = false;
    },
    show_invalid_scan_error(){
      this.error_title = 'Scan error'//this.$vuetify.lang.t('$vuetify.cap_settings.alert_cn_pid_nf_title');
      this.error_body = 'Invalid QR Data format detected'//this.$vuetify.lang.t('$vuetify.cap_settings.alert_cn_pid_nf_body');
      this.display_cn_pid_error = true;
    },
    async save() {
     let validated = this.$refs.capSettingsform.validate();

      if (!validated) {
        return false;
      }

      if (!this.valid_client || !this.valid_project) {
        this.error_title = this.$vuetify.lang.t('$vuetify.cap_settings.alert_cn_pid_nf_title');
        this.error_body = this.$vuetify.lang.t('$vuetify.cap_settings.alert_cn_pid_nf_body');
        this.display_cn_pid_error = true;
        return false;
      }


      //SHOULD ONLY PASS HERE ON SUCCESS
     await this.$store.dispatch('storeCAPS', new clientProjectSettings(
          this.client,
          this.project,
          this.project_distance,
          this.project_shift,
          this.project_tag_code
      ));

      this.emitCloseCurrentComponent();

    },
    handle_changed_client($event) {
      this.client = $event;
      /*window.console.log('client : ');
      window.console.log(this.client);*/
    },
    handle_changed_project($event) {
      this.project = $event;
      /*window.console.log('project : ');
      window.console.log(this.project);*/
    }
  },
  mounted() {
    this.project_distance = this.$store.state.currentClientProjectSettings.project_distance;
    this.project_shift = this.$store.state.currentClientProjectSettings.project_shift;
  },
  mixins: [mobileCheckMixin, appSettings, LMRAVCChildComponentMixin]
}
</script>

<style lang="scss">
  .v-text-field.v-input--is-disabled .v-input__control .v-text-field__details .v-messages{
    color : red !important;
  }
  @mixin afterBg {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 50%;
  }
  // Shockwave
  .btn--shockwave {
    animation: shockwaveJump 6s ease-in-out infinite normal forwards;

    &:after {
      @include afterBg;
      animation: shockwave 6s .15s ease-in-out infinite normal forwards;
    }

    &:before {
      @include afterBg;
      animation: shockwave 6s  ease-in-out infinite normal forwards;
    }
  }

  @keyframes shockwaveJump {
    0% {
      transform: scale(1);
    }
    1% {
      transform: scale(1);
    }
    2% {
      transform: scale(1.08);
    }
    4% {
      transform: scale(0.98);
    }
    6% {
      transform: scale(1.02);
    }
    8% {
      transform: scale(0.98);
    }
    10% {
      transform: scale(0.98);
    }
    11%,100% {
      transform: scale(1);
    }
  }

  @keyframes shockwave {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0px transparent, inset 0 0 0px transparent;
    }
    1% {
      transform: scale(1);
      box-shadow: 0 0 2px rgba(0, 188, 211, 0.60), inset 0 0 1px rgba(0, 188, 211, 0.60);
    }
    10% {
      transform: scale(1.25);
      box-shadow: 0 0 50px rgba(0, 188, 211, 0), inset 0 0 30px rgba(0, 188, 211, 0);
    }
    11%, 100% {
      transform: scale(1);
      box-shadow: 0 0 0px transparent, inset 0 0 0px transparent;
    }
  }
</style>